<template>
  <div class="cert">
    <div class="back" @click="back">
      检测详情（点击可返回上一页面）
    </div>
    <text v-if="showError" style="color: red;justify-content: center;display: flex;">检测信息已被删除</text>
    <div class="box" v-if="infos.length != 0">
      <div class="main">
        <div class="item">
          <div class="left">
            <div class="f-text">样品名称：</div>
            <div>{{ infos[0].sampleName }}</div>
          </div>
        </div>
        <div class="item">
          <div class="left">
            <div class="f-text">采样编号：</div>
            <div>{{ infos[0].sampleNumber }}</div>
          </div>
        </div>
        <div class="item">
          <div class="left">
            <div class="f-text">检测单位：</div>
            <div>{{ checkBy }}</div>
          </div>
        </div>
        <div class="item">
          <div class="left">
            <div class="f-text">被抽单位：</div>
            <div>
              {{ placeName }}
            </div>
          </div>
        </div>
        <div class="dotted-line"></div>
      </div>
      <div class="main" v-for="info in infos">
        <div class="item">
          <div class="left">
            <div class="f-text">检测项目：</div>
            <div>{{ info.projectName }}</div>
          </div>
        </div>
        <div class="item">
          <div class="left">
            <div class="f-text">检测结果：</div>
            <div
              :style="{color: (info.judgeResult=='阴性'||info.judgeResult=='复测：阴性'||info.judgeResult=='合格')?'green':'red'}">
              {{ info.judgeResult }}
            </div>
          </div>
        </div>
        <div class="item">
          <div class="left">
            <div class="f-text">检测时间：</div>
            <div>
              {{ info.testTime }}
            </div>
          </div>
        </div>
        <div class="full-line"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Text } from "view-ui-plus";

export default {
  name: "CertCheckView",
  components: { Text },
  setup() {
  },
  data() {
    return {
      showError: false,
      infos: [],
      checkBy: "",
      placeName: "",
      VUE_APP_API_URL: process.env.VUE_APP_API_URL
    };
  },
  created() {
    document.title = "检测信息";
    this.getCertInfo();
  },
  methods: {
    back() {
      this.$router.back();
    },
    getCertInfo() {
      axios.get(`${this.VUE_APP_API_URL}/open/sample/` + this.$route.params.id)
        .then(response => {
          if (response.data.code === 200) {
            this.checkBy = response.data.data.checkBy;
            this.placeName = response.data.data.placeName;
            axios.post(`${this.VUE_APP_API_URL}/open/sample/clue`, { "sysSampleId": this.$route.params.id })
              .then(response => {
                this.infos = response.data.data.list;
              })
              .finally(() => {
                if (this.infos.length == 0) {
                  this.showError = true;
                }
              });
          } else {
            this.showError = true;
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.cert {
  position: relative;
  padding: 20px;

  .box {
    border-top: solid 1px #000000;
    border-left: solid 1px #000000;
    border-right: solid 1px #000000;
    margin-top: 20px;

    .dotted-line {
      border-top: dashed 1px #000000;
    }

    .full-line {
      border-bottom: solid 1px #000000;
    }

    .main {
      .center {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 32px;
        font-weight: bold;
        padding: 0 20px;
        font-size: 15px;
        color: #000000;
      }

      .item {
        padding: 0 20px;
        display: flex;
        align-items: center;
        min-height: 32px;
        font-size: 15px;
        color: #000000;

        .left {
          display: flex;
          width: 100%;

          .f-text {
            font-weight: bold;
            text-align: justify;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .back {
    justify-content: center;
    align-items: center;
    min-height: 32px;
    font-size: 15px;
    color: #000000;
    display: flex;
    font-weight: bold;
    text-align: justify;
    white-space: nowrap;
  }
}

.cert::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  pointer-events: none;
  background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="80" height="60" viewBox="0 0 100 60"><text x="0" y="40" font-size="12" fill="rgba(0,0,0,0.08)" transform="rotate(-20)" font-weight="bold" font-family="Arial">检测信息</text></svg>') repeat;
  opacity: 0.5;
}
</style>
<style>
.cert .bottom .ivu-checkbox-disabled + span {
  color: #000000;
  font-size: 12px;
}
</style>
